<template>
  <a-upload name="media"
            listType="picture-card"
            class="avatar-uploader"
            :action="action"
            :multiple="multiple"
            :accept="accept"
            :beforeUpload="beforeUpload"
            :showUploadList="false"
            @change="handleChange">
    <slot v-if="imageUrl" name="uploadImage" :imageUrl="imageUrl">
      <div style="width: 112px;height: 112px;position: relative;">
        <a-icon class="upload-img__delete-icon" type="close-circle" @click.prevent.stop="remove" />
        <img :src="imageUrl" class="upload-img" />
      </div>
    </slot>
    <div v-else>
      <slot>
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">
          <slot name="placeholder">
            {{placeholder}}
          </slot>
        </div>
      </slot>
    </div>
  </a-upload>
</template>
<script>
import moment from "moment";
export default {
  name: 'dol-upload-img',
  props: {
    value: {type: Object},
    multiple: {type: Boolean, default: true},            //是否多选
    placeholder: {type: String, default: '上传图片'},
    paramsData: {type: Object},
    serverType: {type: String},
    accept: {type: String, default: '*'},            //允许上传类型
    maxSize: {type: Number, default: 1000},            //最大上传限制，单位K
  },
  data() {
    return {
      loading: false,
    }
  },

  computed: {
    action() {
      const token = this.$store.state.userInfo && this.$store.state.userInfo.USER_ID || '10000001';
      let commonParams = {
        "SERVICE_TYPE": this.serverType,
        "USER_ID": token,
        "H5_CREATE_DATE": moment().format('YYYY-MM-DD HH:mm:ss'),
        "INPUT_PARAM":[this.paramsData],
      }
      let action = '/container-erp/UploadFileAPI';
      action += `?postData=${JSON.stringify(commonParams)}`
      return action;
    },
    imageUrl: {
      get() {
        if (this.value?.FILE_NAME) {
          return this.$Dolphin.path.filePath + this.value?.FILE_NAME;
        } else {
          return '';
        }
      },
      set() {
      },
    },
  },
  methods: {
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.$emit('uploading', {percent: info.file.percent, size: info.file.size});
        this.$store.commit('setLoading', true);
        return
      }
      if (info.file.status === 'done') {
        let result = info.file.response;
        if (this.serverType === 'NodeJs') {
          if (result.success) {
            this.$emit('finished', result?.data);
          }
        } else {
          this.$emit('finished', result?.data);
        }
        this.$store.commit('setLoading', false);
      }
    },
    beforeUpload(file, fileList) {
      if (this.maxSize) {
        if (file.size > this.maxSize * 1024) {
          this.$error({
            title: this.$t('sysMessage'),
            content: `上传文件最大不能超过${this.maxSize}K`,
          });
          return false;
        } else {
          return true;
        }
      }
    },
    remove(file){
      this.$h5Api({
        type: '2010',
        data: [{"GUID_CODE": this.value?.GUID_CODE}],
        showMessage: false,
      }).then(data =>{
        this.$emit('finished', {});
        this.$emit('remove');
      })
    }
  },
}
</script>
<style lang="scss">
.upload-img {
  max-width: 100%;
  max-height: 100%;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.anticon.upload-img__delete-icon {
  font-size: 20px;
  position: absolute;
  right: -14px;
  top: -14px;
  opacity: 0.6;
  cursor: pointer;

  &:hover {
    opacity: 1;
  }
}
</style>
